import { t } from 'i18next'
import React, { useCallback, useMemo, useState, useEffect } from 'react'
import { Alert } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../../Buttons'
import UniversalTableWrapperTest from '../../Table/UniversalTableWrapperTest'
import BootstrapTable from 'react-bootstrap-table-next'
import { useTableState } from '../../Table/TableProvider'
import { getErrorMessageFromApiResponse } from '../../../utils/api/apiUtils'
import { isEmptyGuid } from '../../../utils/emptyGuid'
import styled from 'styled-components'
import useStores from '../../../stores/useStore'
import instMgmtApi from '../../../utils/api/instanceMgmt/instMgmtApi'
import { makeCall } from '../../../utils/api/makeCall'
import { formatedPriceObject } from '../../../utils/formatedPrice'
import { Observer } from 'mobx-react'

export const ResponsiveButton = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
  button {
    width: auto;
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
`

const StyledHeaderCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const WashJobsTable = ({ stationId }) => {
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')
    const [isSaving, setIsSaving] = useState(false)
    const { tableRef } = useTableState()
    const { washStore, uiStore } = useStores()
    const [/*errorStates*/, setErrorStates] = useState({})
    const [loadingStates, setLoadingStates] = useState({})
    const [openJobs, setOpenJobs] = useState([])

    const loadOpenJobs = useCallback(async () => {
        makeCall('getOpenWashItems', async () => {
            let loadjobs = await instMgmtApi.getOpenWashItems()
            setOpenJobs(loadjobs)
        }, setErrorStates, setLoadingStates)

    }, [])
    useEffect(() => {
        loadOpenJobs()
    }, [stationId, loadOpenJobs])

    const columns = useMemo(
        () => [
            {
                dataField: 'rfid',
                text: 'inventory:scanCode',
                sort: true,
                editable: false,
            },
            {
                dataField: 'article.articleNumber',
                text: 'localInventoriesTable:articleNumber',
                sort: true,
                editable: false,
            },
            {
                dataField: 'article.displayName',
                text: 'localInventoriesTable:articleName',
                sort: true,
                editable: false,
            },
            {
                dataField: 'variant.displayName',
                text: 'localInventoriesTable:sizeName',
                sort: true,
                editable: false,
            },
            {
                dataField: 'businesspartner.displayName',
                text: 'washPage:bearer',
                sort: true,
                editable: false,
            },
            {
                dataField: 'costs',
                text: 'washPage:costs',
                sort: true,
                editable: false,
                formatter: (cell, row, rowIndex, extraProps) =>
                    <span>
                        {extraProps.formatedPriceObject(row.costs)}
                    </span>
            },
        ],
        []
    )
    const preparedColumns = useMemo(() => {
        const tmpColumns = [...columns]
        tmpColumns.forEach((tmpColumn) => {
            tmpColumn.headerFormatter = (column, colIndex, components) => {
                switch (tmpColumn.dataField) {
                    default:
                        return (
                            <>
                                <StyledHeaderCell>
                                    {column.text}
                                    {components.sortElement}
                                </StyledHeaderCell>
                            </>
                        )
                }
            }
        })
        tmpColumns.forEach((tmpColumn) => {
            tmpColumn.text = t(tmpColumn.text)
        })
        tmpColumns.find((col) => col.dataField === 'costs').formatExtraData =
        {
            formatedPriceObject,
        }
        const ignoreColumns = () => {
            var result = []
            if (!openJobs.find((x) => !isEmptyGuid(x.variant?.id))) {
                result.push('variant.displayName')
            }
            return result
        }

        return tmpColumns.filter(
            (item) => !ignoreColumns().includes(item.dataField)
        )
    }, [columns, openJobs])
    const handleSave = async () => {
        setIsSaving(true)
        setError('')
        try {
            await await instMgmtApi.clearOpenWashItems()
            await washStore.loadOpenWashItemsCounter()
            loadOpenJobs()
            setSuccess(t('EmployeeFormSidebar:dataSaved'))
        } catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        setIsSaving(false)
    }
    return <Observer>{() => (
        <>
            <UniversalTableWrapperTest>
                <BootstrapTable
                    ref={tableRef}
                    loading={loadingStates.getOpenWashItems}
                    noDataIndication={() => (
                        <div className='no-data-placeholder'>{t('inventory:noData')}</div>
                    )}
                    bootstrap4
                    keyField='id'
                    hover
                    data={openJobs}
                    columns={preparedColumns}
                    bordered={false}
                />
            </UniversalTableWrapperTest>
            {error ? <Alert variant='danger'>{error}</Alert> : null}
            {success ? <Alert variant='success'>{success}</Alert> : null}
            {uiStore.allowBillingWashJobs && <ButtonWithLoadingState
                variant='primary'
                buttonText={t('washPage:billing')}
                isLoading={isSaving || loadingStates.getOpenWashItems}
                disabled={isSaving || !openJobs?.length}
                onClick={(e) => handleSave()}
            />}
        </>
    )}</Observer>
}

export default WashJobsTable
